/* eslint-disable array-callback-return */
/* eslint-disable no-self-assign */
import moment from 'moment';
import { firestore } from '../../fire';
import momentz from 'moment-timezone';

export const formatComma = (volume) => {
  return volume ? volume.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';
};

export const formatMoney = (money) => {
  return (Math.round(money * 100, 0) / 100).toFixed(2);
};

export const formatVolatility = (vol) => {
  return Math.round(vol * 10, 0) / 10;
};

export const formatPercent = (percent) => {
  return Math.round(percent * 1000, 0) / 10;
};

export const format1Decimal = (number) => {
  return (Math.round(number * 10) / 10).toFixed(1);
};

export const format2Decimal = (number) => {
  return (Math.round(number * 100) / 100).toFixed(2);
};
export const findCap = (large, mid, small) => {
  if (large === 1) {
    return 'Large';
  } else if (mid === 1) {
    return 'Mid';
  } else if (small === 1) {
    return 'Small';
  } else {
    return '-';
  }
};

export const returnEarning = (row, extra) => {
  if (!extra || !row) return '';
  extra.sort((a, b) => {
    return a['date'].localeCompare(b['date']);
  });
  if (extra.length > 0) {
    var filteredResult = Object.values(extra).filter(
      (obj) => obj.type === 'Earnings' && new Date(obj.date) > new Date()
    );

    if (filteredResult.length) return filteredResult[0].date;
    else return '';
  }
  return '';
};

export const returnDivid = (row, extra) => {
  let filteredResults = extra.filter((cal) => {
    return cal.type === 'ExDiv';
  });
  if (!extra || !row) return ['', ''];
  extra.sort((a, b) => {
    return a['date'].localeCompare(b['date']);
  });
  if (filteredResults.length > 0) {
    var today = new Date();
    var tomorrowStr = '';
    if (today.getDay() === 5)
      tomorrowStr = moment(today, 'YYYY-MM-DD')
        .add(3, 'd')
        .format('YYYY-MM-DD');
    else if (today.getDay() === 6)
      tomorrowStr = moment(today, 'YYYY-MM-DD')
        .add(2, 'd')
        .format('YYYY-MM-DD');
    else
      tomorrowStr = moment(today, 'YYYY-MM-DD')
        .add(1, 'd')
        .format('YYYY-MM-DD');

    var availableExtras = filteredResults.filter(
      (data) => data['date'] === tomorrowStr
    );

    if (availableExtras.length > 0) {
      return ['D', availableExtras[0]['date']];
    }
  }
  return ['', ''];
};

export const openNOC = (item) => {
  localStorage.setItem('SYMBOL', item);
};
export const paginate = (array, page_size, page_number) => {
  // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
  return array.slice((page_number - 1) * page_size, page_number * page_size);
};

export const setFilterUOA = (
  fullUOA,
  stockFilter,
  etfFilter,
  smallFilter,
  midFilter,
  largeFilter,
  IVUP,
  IVDOWN
) => {
  var localUOA = [];

  if (stockFilter && etfFilter) {
    localUOA = fullUOA.filter((data) => {
      return data.AssetType === 'S' || data.AssetType === 'E';
    });
  } else if (stockFilter && !etfFilter) {
    localUOA = fullUOA.filter((data) => {
      return data.AssetType === 'S';
    });
  } else if (!stockFilter && etfFilter) {
    localUOA = fullUOA.filter((data) => {
      return data.AssetType === 'E';
    });
  } else {
    localUOA = fullUOA;
  }

  if (IVUP && IVDOWN) {
    localUOA = localUOA.filter((data) => {
      return data.atmchg > 0 || data.atmchg <= 0;
    });
  } else if (IVUP && !IVDOWN) {
    localUOA = localUOA.filter((data) => {
      return data.atmchg > 0;
    });
  } else if (!IVUP && IVDOWN) {
    localUOA = localUOA.filter((data) => {
      return data.atmchg <= 0;
    });
  } else {
    localUOA = localUOA;
  }
  if (smallFilter && midFilter && largeFilter) {
    localUOA = localUOA.filter((data) => {
      return data.largecap === 1 || data.midcap === 1 || data.smallcap === 1;
    });
  } else if (smallFilter && !midFilter && !largeFilter) {
    localUOA = localUOA.filter((data) => {
      return data.smallcap === 1;
    });
  } else if (!smallFilter && midFilter && !largeFilter) {
    localUOA = localUOA.filter((data) => {
      return data.midcap === 1;
    });
  } else if (!smallFilter && !midFilter && largeFilter) {
    localUOA = localUOA.filter((data) => {
      return data.largecap === 1;
    });
  } else if (smallFilter && midFilter && !largeFilter) {
    localUOA = localUOA.filter((data) => {
      return data.smallcap === 1 || data.midcap === 1;
    });
  } else if (smallFilter && !midFilter && largeFilter) {
    localUOA = localUOA.filter((data) => {
      return data.smallcap === 1 || data.largecap === 1;
    });
  } else if (!smallFilter && midFilter && largeFilter) {
    localUOA = localUOA.filter((data) => {
      return data.midcap === 1 || data.largecap === 1;
    });
  } else {
    // eslint-disable-next-line no-self-assign
    localUOA = localUOA;
  }
  return localUOA;
};

export const UOAEarning = async (Data) => {
  for (var data of Data) {
    var earning = await firestore
      .collection('calendars')
      .doc(data['Symbol'].replace('/', '-'))
      .get();
    var extra = [];
    if (earning.data()) {
      // eslint-disable-next-line array-callback-return, no-loop-func
      Object.keys(earning.data()).map((key) => {
        extra.push(earning.data()[key]);
      });
      data['earnings'] = returnEarning(data, extra);
      data['div'] = returnDivid(data, extra)[0];
      data['divdate'] = returnDivid(data, extra)[1];
    }
  }
};

export const UOAETATIME = async () => {
  const now = new Date();
  let endingTime = moment('4:00pm', 'h:mma');
  let startingTime = moment('12:00am', 'h:mma');
  let tenAM = moment('10:00am', 'h:mma');
  let myNowText = momentz().tz('America/New_York').format('h:mma');

  let convertedText = moment(myNowText, 'h:mma');

  let Data = [];
  const snapShot = await firestore.collection('UOAData').get();
  snapShot.docs.forEach((doc) => {
    const data = doc.data();
    data['mkt'] = findCap(data['largecap'], data['midcap'], data['smallcap']);

    Data.push(data);
  });
  let currentMin;
  let nextMin;
  let nextRefresh;
  const newCondition =
    moment(convertedText).isAfter(startingTime) &&
    moment(convertedText).isBefore(tenAM);
  if (newCondition || moment(convertedText).isAfter(endingTime)) {
    nextRefresh = '10:00am';
  } else {
    currentMin = now.getMinutes();
    nextMin = 10 - (currentMin % 10);
    nextRefresh = moment(now, 'hh:mm').add(nextMin, 'minutes').format('hh:mm');
  }

  const newData = await Promise.all(
    Data.map(async (data) => {
      var earning = await firestore
        .collection('calendars')
        .doc(data['Symbol'].replace('/', '-'))
        .get();
      let extra = [];
      let earningObject = earning.data();
      if (earningObject) {
        Object.keys(earningObject).map((key) => {
          extra.push(earningObject[key]);
        });
        data['div'] = returnDivid(data, extra)[0];
        data['divdate'] = returnDivid(data, extra)[1];
        if (Object.keys(earningObject).length > 0) {
          const newDate = new Date();
          const momentDate = moment(newDate).format('YYYY-MM-DD');
          let filteredResult = Object.values(earningObject).filter(
            (obj) => obj.type === 'Earnings' && obj.date >= momentDate
          );
          if (filteredResult.length) {
            return {
              ...data,
              earningObject: filteredResult[0],
              earningss: filteredResult[0].date,
            };
          } else {
            return { ...data, earningObject: { date: '' }, earningss: '' };
          }
        }
      } else {
        return { ...data, earningObject: { date: '' }, earningss: '' };
      }
    })
  );
  const obj = {
    nextRefresh: nextRefresh,
    newData: newData,
    nextMin: nextMin,
  };
  return obj;
};



// WEBPACK FOOTER //
// ./src/Pages/UnusualOptionsActivity/utils.js